import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TourService } from '../tour.service';
import { DemoExit } from './demo-exit';
import { DEMO_TOUR_ID } from './demo-mode';

/**
 * Le bandeau d'un onglet de démonstration, qui ne se ferme pas : les données sont fictives, et rien
 * n'est enregistré. Il relance le parcours une fois terminé ou quitté, et propose à tout moment de
 * quitter la démonstration.
 */
@Component({
  selector: 'app-demo-banner',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule],
  template: `
    @if (tourId) {
      <div class="demo-banner" role="status">
        <span><strong>Démonstration</strong> — données fictives : rien n’est enregistré</span>
        @if (!tours.tour()) {
          <button mat-button (click)="tours.start(tourId)">Rejouer le parcours</button>
        }
        <button mat-button class="leave" (click)="exit.leave()">Quitter la démonstration</button>
      </div>
    }
  `,
  styles: `
    .demo-banner {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 4px 16px;
      background: var(--mat-sys-tertiary-container);
      color: var(--mat-sys-on-tertiary-container);
      font: var(--mat-sys-body-medium);
    }

    .leave {
      margin-left: auto;
    }
  `,
})
export class DemoBanner {
  protected readonly tourId = inject(DEMO_TOUR_ID, { optional: true });
  protected readonly tours = inject(TourService);
  protected readonly exit = inject(DemoExit);
}
